/* FLÁYR – productpagina: eerst maat kiezen en levertijd-countdown */
(() => {
  const picker = document.querySelector('variant-picker[context="main_product"]');

  // Maat niet vooraf selecteren, tenzij er een variant in de URL staat
  if (picker && !new URLSearchParams(location.search).has('variant')) {
    const formId = picker.getAttribute('form-id');
    const sizeFieldset = [...picker.querySelectorAll('fieldset.variant-picker__option')]
      .find((fieldset) => /size|maat/i.test(fieldset.querySelector('legend')?.textContent || ''));

    if (sizeFieldset) {
      const isProductButton = (button) => button.getAttribute('form') === formId || button.closest('form')?.getAttribute('id') === formId;
      const productButtons = () => [...document.querySelectorAll('button[type="submit"]')].filter(isProductButton);
      const originalLabels = new Map();
      let sizeChosen = false;

      sizeFieldset.querySelectorAll('input[type="radio"]').forEach((radio) => { radio.checked = false; });
      document.documentElement.classList.add('flayr-size-pending');

      productButtons().forEach((button) => {
        if (button.disabled) return;
        originalLabels.set(button, button.textContent);
        button.textContent = 'Select a size';
      });

      sizeFieldset.addEventListener('change', () => {
        if (sizeChosen) return;
        sizeChosen = true;
        document.documentElement.classList.remove('flayr-size-pending', 'flayr-size-alert');
        originalLabels.forEach((label, button) => {
          if (button.textContent === 'Select a size') button.textContent = label;
        });
      });

      const blockUntilSizeChosen = (event) => {
        document.documentElement.classList.add('flayr-size-alert');
        sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => document.documentElement.classList.remove('flayr-size-alert'), 1200);
        event.preventDefault();
        event.stopImmediatePropagation();
      };

      document.addEventListener('click', (event) => {
        const button = event.target.closest('button[type="submit"]');
        if (!sizeChosen && button && isProductButton(button)) blockUntilSizeChosen(event);
      }, true);

      document.addEventListener('submit', (event) => {
        if (!sizeChosen && event.target.getAttribute?.('id') === formId) blockUntilSizeChosen(event);
      }, true);
    }
  }

  // Levertijd-countdown (cut-off 16:00 Nederlandse tijd, verzending op werkdagen)
  const countdown = document.querySelector('[data-flayr-countdown]');

  if (countdown) {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    });
    const cutoff = 16 * 60;

    const render = () => {
      const parts = Object.fromEntries(formatter.formatToParts(new Date()).map((part) => [part.type, part.value]));
      const day = parts.weekday;
      const minutes = Number(parts.hour) * 60 + Number(parts.minute);
      const beforeCutoff = !['Sat', 'Sun'].includes(day) && minutes < cutoff;

      if (beforeCutoff) {
        const left = cutoff - minutes;
        const hours = Math.floor(left / 60);
        const time = `${hours ? `${hours}h ` : ''}${left % 60}m`;
        const promise = day === 'Fri' ? 'ships <strong>today</strong>' : 'delivered <strong>tomorrow</strong>';
        countdown.innerHTML = `Order within <strong>${time}</strong>, ${promise}`;
      } else {
        const shipsMonday = day === 'Fri' || day === 'Sat';
        countdown.innerHTML = `Order now, ships <strong>${shipsMonday ? 'Monday' : 'tomorrow'}</strong>`;
      }
    };

    render();
    setInterval(render, 30000);
  }
})();
